export default "__VITE_ASSET__CzSCC8Ku__"